// kontaktTerminFenster.ts — K8/K7/J3: DAS EINE Zeitfenster für die beiden
// Kontakt-Terminlisten (Termine-Bereich der Mail-Leiste und Termine-Reiter des
// Vorgangs). Beide übergeben `from`/`to` explizit an `listContactTermine` bzw.
// `listCommonTermineByAddresses` — die Server-Defaults bleiben damit
// unangetastet, und die beiden Ansichten zeigen garantiert denselben Bereich.
//
// Warum Vergangenheit UND Zukunft: die Anforderung lautet „alle Termine, die
// ich je hatte oder haben werde". Die alten Defaults (−30/+90 Tage bzw. nur
// Zukunft) verfehlen das. Startstufe ist deshalb ein Jahr in beide Richtungen;
// die zweite Stufe („Früher liegende Termine laden") reicht drei Jahre zurück
// und ist bewusst ein ausdrücklicher Nutzerschritt, weil sie deutlich mehr
// Graph-Kalenderzeitraum scannt.

export const KONTAKT_FENSTER_STUFEN = [
    { zurueckMonate: 12, vorMonate: 12 },
    { zurueckMonate: 36, vorMonate: 12 },
] as const;

export type KontaktFensterStufe = 0 | 1;

/** Lokaler Tagesbeginn bzw. -ende, um `monate` verschoben. */
function monatsGrenze(monate: number, endeDesTages: boolean): string {
    const d = new Date();
    d.setMonth(d.getMonth() + monate);
    if (endeDesTages) d.setHours(23, 59, 59, 999);
    else d.setHours(0, 0, 0, 0);
    return d.toISOString();
}

/**
 * Das Zeitfenster einer Stufe als ISO-Strings auf lokalen Tagesgrenzen.
 * Stufe 0 ist der Start, Stufe 1 der Nachlade-Schritt.
 */
export function fensterFuer(stufe: KontaktFensterStufe): { from: string; to: string } {
    const { zurueckMonate, vorMonate } = KONTAKT_FENSTER_STUFEN[stufe];
    return {
        from: monatsGrenze(-zurueckMonate, false),
        to: monatsGrenze(vorMonate, true),
    };
}

/** Gibt es eine weitere Stufe zum Nachladen? */
export function hatWeitereStufe(stufe: KontaktFensterStufe): boolean {
    return stufe + 1 < KONTAKT_FENSTER_STUFEN.length;
}
